import { makeStyles } from '@material-ui/core/styles'
export const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: 100,
        padding: 20,
        margin: '0 auto'
    },
    section: {
        marginBottom: 30
    },
    sectionTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 15
    },
    items: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
        marginBottom: 10
    },
    item: {
        backgroundColor: '#f0f0f0',
        borderRadius: 15,
        padding: '10px 15px',
        fontSize: 14,
        fontWeight: 'normal',
        color: '#000',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: '#d6d6d6'
        }
    },
    titleBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer'
    }
}))
